// Design tokens for sentiment-based UI components
export type Sentiment = 'positive' | 'negative' | 'neutral' | 'warning';

// Text color classes for each sentiment
export const sentimentText: Record<Sentiment, string> = {
  positive: 'text-green-700 dark:text-green-400',
  negative: 'text-red-700 dark:text-red-400',
  warning: 'text-yellow-700 dark:text-yellow-400',
  neutral: 'text-gray-700 dark:text-gray-400',
};

// Icon background color classes for each sentiment
export const sentimentIconBg: Record<Sentiment, string> = {
  positive: 'bg-green-100 dark:bg-green-900/20',
  negative: 'bg-red-100 dark:bg-red-900/20',
  warning: 'bg-yellow-100 dark:bg-yellow-900/20',
  neutral: 'bg-gray-100 dark:bg-gray-900/20',
};

// Accent border color classes for each sentiment
export const sentimentAccentBorder: Record<Sentiment, string> = {
  positive: 'border-l-green-500',
  negative: 'border-l-red-500',
  warning: 'border-l-yellow-500',
  neutral: 'border-l-gray-500',
};

// Trend pill background color classes for each sentiment
export const sentimentTrendPill: Record<Sentiment, string> = {
  positive: 'bg-green-50 text-green-700 border-green-200 dark:bg-green-900/10 dark:text-green-400 dark:border-green-800',
  negative: 'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/10 dark:text-red-400 dark:border-red-800',
  warning: 'bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-900/10 dark:text-yellow-400 dark:border-yellow-800',
  neutral: 'bg-gray-50 text-gray-700 border-gray-200 dark:bg-gray-900/10 dark:text-gray-400 dark:border-gray-800',
};
